import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable, Subject} from 'rxjs';
import {AlertService} from './alert.service';
import {Router} from '@angular/router';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {
  private profileImageSubject = new Subject<string>();
  profileImage$ = this.profileImageSubject.asObservable();

  constructor(public http: HttpClient, public alertService: AlertService, private router: Router, public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  login(data: any): Observable<any> {
    return this.postRequest(AppUrl.LOGIN, data);
  }

  self(params = {}): Observable<any> {
    return this.getRequest(AppUrl.SELF, params);
  }

  update(data: any): Observable<any> {
    return this.putRequest(AppUrl.UPDATE_SELF(), data);
  }

  logout(): Observable<any> {
    return this.postRequest(AppUrl.LOGOUT());
  }

  updateProfile(data: any, uniqueId:any) {
    return this.putRequest(AppUrl.UPDATE_PROFILE_IMAGE(uniqueId), data);
  }

  updatePassword(data: any) {
    return this.putRequest(AppUrl.UPDATE_PASSWORD(), data);
  }

  updateProfileImage(newImageUrl: string) {
    this.profileImageSubject.next(newImageUrl);
  }
}
